import React from 'react';
import Truncate from 'react-truncate';
import i18next from 'i18next';
import classNames from 'classnames';
import Immutable from 'immutable';

import { WysiwygField, useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink, ImageFromField } from '@uncinc/react-drupal-core';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
} from '../../../../config/constants';

import './style.scss';

const NodeDossierTeaser = ({ entity, dateLabel, isLarge }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'processed']);
  const link = entity.getIn(['paths', 'nl']);
  const image = entity.getIn(['field_teaser_media', 0]);
  const currentStatus = entity.getIn(['field_dossier_status', 0, 'entity', 'name', 0, 'value']);

  const { width } = useWindowDimensions();
  const isTablet = width <= SCREEN_NORMAL && width > SCREEN_TABLET;

  const teaserClass = classNames('DossierTeaser', {
    'DossierTeaser--large': isLarge,
  });
  const bodyTruncateLines = (!isLarge && isTablet) ? 2 : 4;

  return (
    <CoreLink className={teaserClass} to={link}>
      <div className="DossierTeaser__image-container">
        <ImageFromField
          alt="DossierTeaser"
          className="DossierTeaser__image"
          field={image}
          imageStyles={Immutable.Map({
            [SCREEN_MOBILE]: 'teaser_image',
            [SCREEN_NORMAL]: isLarge ? 'teaser_square' : 'teaser_image',
          })}
        />
        <div className="DossierTeaser__image-overlay" />
      </div>
      <div className="DossierTeaser__content">
        <div className="DossierTeaser__content__tagsWrapper">
          <span className="DossierTeaser__content__label">{i18next.t('node.dossier.title')}</span>
          <span className="DossierTeaser__content__status">{currentStatus}</span>
        </div>

        <h2 className="DossierTeaser__content__title">
          <Truncate lines={2} ellipsis={<span>...</span>}>
            {title}
          </Truncate>
        </h2>
        {body && (
          <p className="DossierTeaser__content__body">
            <Truncate lines={bodyTruncateLines} ellipsis={<span>...</span>}>
              <WysiwygField
                html={body}
              />
            </Truncate>
          </p>
        )}
        <p className="DossierTeaser__content__date">
          {dateLabel}
        </p>
      </div>
    </CoreLink>
  );
};

export default NodeDossierTeaser;
